import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import { whatsappUrl, WHATSAPP_PHONE } from "@/lib/whatsapp";
import { WhatsappGlyph } from "@/components/WhatsappFab";
import { BOUTIQUE_ENABLED } from "@/lib/features";

export default function Footer() {
  return (
    <footer
      className="bg-[#00224D] text-pearl/90 grain relative"
      data-testid="main-footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="/brand/shinrai-logo-slogan-white.png"
            alt="ShinRai Consulting — switch on confidence"
            className="h-20 w-auto mb-6"
          />
          <p className="text-pearl/70 max-w-md leading-relaxed">
            Cabinet de conseil indépendant. Nous combinons Lean,
            neurosciences et IA pour aider les dirigeants à reprendre le pilotage
            de leur organisation. Interventions dans le monde entier.
          </p>
          <div className="mt-8 flex flex-col gap-2 text-sm text-pearl/70">
            <a href="mailto:info@shinrai.fr" className="flex items-center gap-2 hover:text-pearl transition" data-testid="footer-email">
              <Mail size={14} /> info@shinrai.fr
            </a>
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-[#25D366] transition"
              data-testid="footer-whatsapp"
            >
              <WhatsappGlyph size={14} /> WhatsApp · +33 6 62 74 50 46
            </a>
            <span className="flex items-center gap-2">
              <MapPin size={14} /> Interventions présentiel, hybride & remote — monde entier
            </span>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono-overline text-pearl/40 mb-4">Naviguer</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-pearl transition">Accueil</Link></li>
            {BOUTIQUE_ENABLED && <li><Link to="/boutique" className="hover:text-pearl transition">Boutique</Link></li>}
            <li><Link to="/a-propos" className="hover:text-pearl transition">À propos</Link></li>
            <li><Link to="/blog" className="hover:text-pearl transition">Études & blog</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono-overline text-pearl/40 mb-4">Méthode</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#methode" className="hover:text-pearl transition">Les 3 piliers</a></li>
            <li><a href="/#parcours" className="hover:text-pearl transition">Parcours 6 mois</a></li>
            <li><a href="/#diagnostic" className="hover:text-pearl transition">Diagnostic gratuit</a></li>
            <li><a href="/#faq" className="hover:text-pearl transition">FAQ</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono-overline text-pearl/40 mb-4">Prendre contact</div>
          <p className="text-sm text-pearl/70 mb-5">
            45 minutes. Aucune obligation. Un regard honnête sur ton organisation.
          </p>
          <a href="/#diagnostic" className="btn-white" data-testid="footer-cta-diagnostic">
            Diagnostic gratuit <ArrowUpRight size={14} />
          </a>
          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex items-center gap-2 text-sm text-pearl/80 hover:text-[#25D366] transition"
            data-testid="footer-cta-whatsapp"
          >
            <WhatsappGlyph size={14} /> ou écris-moi sur WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t border-pearl/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-pearl/40">
          <span>© {new Date().getFullYear()} ShinRai Consulting. Tous droits réservés.</span>
          <div className="flex flex-wrap gap-x-5 gap-y-1">
            <Link to="/mentions-legales" className="hover:text-pearl/80 transition" data-testid="footer-legal-mentions">Mentions légales</Link>
            <Link to="/cgv" className="hover:text-pearl/80 transition" data-testid="footer-legal-cgv">CGV</Link>
            <Link to="/politique-cookies" className="hover:text-pearl/80 transition" data-testid="footer-legal-cookies">Politique de cookies</Link>
            <span>shinrai.fr — Worldwide</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
